import * as React from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import services from '../../../services';
import { $ } from 'jquery';
import Swal from 'sweetalert2';

var thisState;
var NumeroAE;
var NumeroIVDP;

class NumericCellDinamic extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      NumeroAE: null,
      NumeroIVDP: null
    };
    
    // Referência para o componente NumericCellDinamic
    this.numericCellDinamicRef = React.createRef(); 
  }
  static ChangeValueById(Campo , id) {

    var NumeroRegisto = null;
    var Capacidade = null;
    var idMotivo = document.getElementById('Motivo_fisc')
    if(Campo == "Registo"){
      NumeroRegisto = parseInt(id.text);
      if(thisState.props.dataItem.Correlativa != null){
        Capacidade = (parseFloat(thisState.props.dataItem.Correlativa.text.split(" - ")[3].replace(" cl", ""))/100);
      }else if(thisState.props.dataItem.CapacidadeFDO != null){
        Capacidade = (parseFloat(thisState.props.dataItem.CapacidadeFDO.text.replace(" cl", ""))/100); 
      }
    }
    if(Campo == "Correlativa"){
      Capacidade = (parseFloat(id.text.split(" - ")[3].replace(" cl", ""))/100);
      NumeroRegisto = parseInt(thisState.props.dataItem.Registo.text);
    }
    if(Campo == "Capacidade"){
      if(thisState != undefined){
        NumeroRegisto = parseInt(thisState.props.dataItem.Registo.text);
      }
      
      Capacidade = (parseFloat(id.text.replace(" cl", ""))/100);
    }

    if(NumeroRegisto != null && Capacidade != null){
      (async () => {
        
        const data2 = {
          "NumeroRegisto" : NumeroRegisto , 
          "idMotivo" : parseInt(idMotivo.value) , 
          "capacidade": Capacidade
        }

        const NumeroGarrafas = await services.apiCall.requestApi(
          "/Fiscalizacao/GetNumeroGarrafasFDO",
          data2,
          "get"
        );
  
          if(NumeroGarrafas){
            if(NumeroGarrafas.data == ""){
              NumeroAE = null
              NumeroIVDP = null
              thisState.setState({ NumeroAE : null, NumeroIVDP: null });
            }else{
              NumeroAE = NumeroGarrafas.qtAE
              NumeroIVDP = NumeroGarrafas.qtIVDP
              thisState.setState({ NumeroAE : NumeroGarrafas.qtAE, NumeroIVDP: NumeroGarrafas.qtIVDP });
            }
          }else{
            NumeroAE = null
            NumeroIVDP = null
            thisState.setState({ NumeroAE : null, NumeroIVDP: null });
          };        
      })();
    }
  }

  componentDidMount(){
    thisState = this;
  }

  handleChange = e => {
    if (this.props.onChange) {
      this.props.onChange({
        dataIndex: 0,
        dataItem: this.props.dataItem,
        field: this.props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value
      });
      if(this.props.field == "NGarrafasIVDP"){
        NumeroIVDP = e.target.value
      }else if(this.props.field == "NGarrafasAE"){
        NumeroAE = e.target.value
      }
      
    }
  };
  
  render() {
    const { dataItem, field = '' } = this.props;
    

    let indexId = dataItem.ProductID;
    if(dataItem.inEdit === true){
      indexId = 0;
    }
  
  if(document.getElementsByClassName("NGarrafasIVDP")[indexId] != undefined){
    if(NumeroIVDP != null){
      document.getElementsByClassName("NGarrafasIVDP")[indexId].value = String(NumeroIVDP);
      document.getElementsByClassName("NGarrafasIVDP")[indexId].text = String(NumeroIVDP);
      dataItem.NGarrafasIVDP = String(NumeroIVDP);
    }else{
      document.getElementsByClassName("NGarrafasIVDP")[indexId].value = dataItem.NGarrafasIVDP != undefined ? dataItem.NGarrafasIVDP : "";
      document.getElementsByClassName("NGarrafasIVDP")[indexId].text = dataItem.NGarrafasIVDP != undefined ? dataItem.NGarrafasIVDP : ""
      dataItem.NGarrafasIVDP = dataItem.NGarrafasIVDP != undefined ? dataItem.NGarrafasIVDP : ""
    }
  }
  
  if(document.getElementsByClassName("NGarrafasAE")[indexId] != undefined){
  
    if(NumeroAE != null){
      document.getElementsByClassName("NGarrafasAE")[indexId].value = String(NumeroAE);
      document.getElementsByClassName("NGarrafasAE")[indexId].text = String(NumeroAE);
      dataItem.NGarrafasAE = String(NumeroAE);
    }else{
      document.getElementsByClassName("NGarrafasAE")[indexId].value = dataItem.NGarrafasAE != undefined ? dataItem.NGarrafasAE : ""
      document.getElementsByClassName("NGarrafasAE")[indexId].text = dataItem.NGarrafasAE != undefined ? dataItem.NGarrafasAE : ""
      dataItem.NGarrafasAE = dataItem.NGarrafasAE != undefined ? dataItem.NGarrafasAE : ""
    }
      
  }
  

    let dataValue = dataItem[field] === null ? '' : dataItem[field];

    if (field === "NGarrafasIVDP") {
      return (
        <td>
          {dataItem.inEdit ? (
            <input
              type="text"
              id="numberboxcell"
              className="NGarrafasIVDP"
              onChange={this.handleChange}
              value={dataValue != null ? dataValue : undefined}
            />
          ) : (
            dataValue != null ? dataValue.toString() : undefined
          )}
        </td>
      );
    }

    if (field === "NGarrafasAE") {
      return (
        <td>
          {dataItem.inEdit ? (
            <input
              type="text"
              id="numberboxcell"
              className="NGarrafasAE"
              onChange={this.handleChange}
              value={dataValue != null ? dataValue : undefined}
            />
          ) : (
            dataValue != null ? dataValue.toString() : undefined
          )}
        </td>
      );
    }

    return null;
  }
}

export default NumericCellDinamic;
